import {createSelector} from 'reselect';
import {getFrom} from '@pluto/utils';
import {LoadingState} from '../LoadingTypes';

const REDUCER_NAME = 'loading';

export enum LoadReducer {
    loaded = 'loaded',
    loading = 'loading',
}

export interface State {
    [REDUCER_NAME]: LoadingState;
}

export const stateSelector = (state: State) => state[REDUCER_NAME];

export const loadedSelector = createSelector(stateSelector, getFrom(LoadReducer.loaded));
export const loadingSelector = createSelector(
    stateSelector,
    getFrom(LoadReducer.loading)
);

export const isLoading = (tag = '') =>
    createSelector(loadingSelector, loadedSelector, (loading, loaded) => {
        return Boolean(tag) ? loading.has(tag) && !loaded.has(tag) : loading.size !== 0;
    });
